import { useState, useEffect } from "react"
import ContactForm from "./components/ContactForm"
import "./App.css"

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL!
const DEV_MODE = process.env.REACT_APP_DEV_MODE === "true"

const MOCK_CONTACT = {
  firstName: "Jane",
  lastName: "Demo",
  dateOfBirth: "1985-04-12",
  email: "jane.demo@example.com",
  phone: "+1 555-867-5309",
  address1: "123 Maple Street",
  city: "Nashville",
  state: "TN",
  postalCode: "37201",
  customFields: [
    { fieldKey: "contact.gender",                          value: "Female" },
    { fieldKey: "contact.are_you_a_tobacco_smoker",        value: "No" },
    { fieldKey: "contact.timezone",                        value: "America/Chicago" },
    { fieldKey: "contact.what_is_your_height_and_weight",   value: "5'6\"" },
    { fieldKey: "contact.weight",                          value: "148" },
    { fieldKey: "contact.magi",                            value: "$72,000" },
    { fieldKey: "contact.house_hold_size",                 value: "4" },
    { fieldKey: "contact.county",                          value: "Davidson" },
    { fieldKey: "contact.clients_spouse",                    value: "Michael" },
    { fieldKey: "contact.contactclients_spouse_lastname",   value: "Demo" },
    { fieldKey: "contact.spouse_date_of_birth",             value: "1983-09-28" },
    { fieldKey: "contact.spouse_height",                   value: "5'11\"" },
    { fieldKey: "contact.spouse_weight",                   value: "185" },
    { fieldKey: "contact.spouse_email",                    value: "michael.demo@example.com" },
    { fieldKey: "contact.spouse_phone",                    value: "+1 555-867-5310" },
    { fieldKey: "contact.spouse_gender",                   value: "Male" },
    { fieldKey: "contact.spouse_a_tobacco_smoker",         value: "No" },
    { fieldKey: "contact.spouse_relationship",             value: "Spouse" },
    { fieldKey: "contact.dependent_1",                       value: "Emma" },
    { fieldKey: "contact.contactdependent_1_lastname",      value: "Demo" },
    { fieldKey: "contact.dependent_1_dob",                  value: "2012-06-15" },
    { fieldKey: "contact.dependent_1_height",              value: "4'8\"" },
    { fieldKey: "contact.dependent_1_weight",              value: "90" },
    { fieldKey: "contact.dependent_1_gender",              value: "Female" },
    { fieldKey: "contact.dependent_1_a_tobacco_smoker",    value: "No" },
    { fieldKey: "contact.dependent_1_relationship",        value: "Daughter" },
    { fieldKey: "contact.dependent_2",                       value: "Liam" },
    { fieldKey: "contact.dependent_2_lastname",             value: "Demo" },
    { fieldKey: "contact.dependent_2_dob",                 value: "2015-02-20" },
    { fieldKey: "contact.dependent_2_height",              value: "4'1\"" },
    { fieldKey: "contact.dependent_2_weight",              value: "65" },
    { fieldKey: "contact.dependent_2_gender",              value: "Male" },
    { fieldKey: "contact.dependent_2_a_tobacco_smoker",    value: "No" },
    { fieldKey: "contact.dependent_2_relationship",        value: "Son" },
    { fieldKey: "contact.policy_1_carrier",              value: "Blue Cross Blue Shield" },
    { fieldKey: "contact.policy_1_product_name",         value: "Silver PPO 3000" },
    { fieldKey: "contact.policy_1_number",               value: "BCB-2024-883421" },
    { fieldKey: "contact.policy_1_monthly_premium",      value: "$824.00" },
    { fieldKey: "contact.policy_1_application_date",     value: "2023-11-01" },
    { fieldKey: "contact.policy_1_effective_date",       value: "2024-01-01" },
    { fieldKey: "contact.policy_2_carrier",              value: "MetLife" },
    { fieldKey: "contact.policy_2_product_name",         value: "Dental Plus Family" },
    { fieldKey: "contact.policy_2_number",               value: "MET-2024-119043" },
    { fieldKey: "contact.policy_2_monthly_premium",      value: "$68.00" },
    { fieldKey: "contact.policy_2_application_date",     value: "2023-11-01" },
    { fieldKey: "contact.policy_2_effective_date",       value: "2024-01-01" },
    { fieldKey: "contact.policy_3_carrier",              value: "VSP" },
    { fieldKey: "contact.policy_3_product_name",         value: "Vision Choice Plan" },
    { fieldKey: "contact.policy_3_number",               value: "VSP-2024-550712" },
    { fieldKey: "contact.policy_3_monthly_premium",      value: "$24.50" },
    { fieldKey: "contact.policy_3_application_date",     value: "2023-11-01" },
    { fieldKey: "contact.policy_3_effective_date",                        value: "2024-01-01" },
    { fieldKey: "contact.past_policy_1_carrier__product",                 value: "Aetna / Bronze HMO 6500" },
    { fieldKey: "contact.past_policy_1_line_of_business",                 value: "Health" },
    { fieldKey: "contact.past_policy_1_effective_date_cancellation_date", value: "01/01/2023 - 12/31/2023" },
    { fieldKey: "contact.past_policy_1_archived_date",                    value: "2024-01-15" },
    { fieldKey: "contact.past_policy_1_action_dropdown",                  value: "Cancelled" },
    { fieldKey: "contact.past_policy_2_carrier__product",                 value: "Cigna / Silver PPO 4000" },
    { fieldKey: "contact.past_policy_2_line_of_business",                 value: "Health" },
    { fieldKey: "contact.past_policy_2_effective_date_cancellation_date", value: "01/01/2022 - 12/31/2022" },
    { fieldKey: "contact.past_policy_2_archived_date",                    value: "2023-01-10" },
    { fieldKey: "contact.past_policy_2_action_dropdown",                  value: "Replaced" },
    { fieldKey: "contact.doctor_1_name",                                  value: "Dr. Sarah Mitchell" },
    { fieldKey: "contact.doctor_1_specialty",                             value: "Primary Care" },
    { fieldKey: "contact.doctor_1_address",                               value: "1200 Medical Center Dr, Nashville, TN" },
    { fieldKey: "contact.doctor_2_name",                                  value: "Dr. James Patel" },
    { fieldKey: "contact.doctor_2_specialty",                             value: "Cardiology" },
    { fieldKey: "contact.doctor_2_address",                               value: "450 Heart Blvd, Nashville, TN" },
    { fieldKey: "contact.rx_1_name",                                      value: "Lisinopril" },
    { fieldKey: "contact.rx_1_dosage",                                    value: "10mg" },
    { fieldKey: "contact.rx_1_quantity",                                  value: "30" },
    { fieldKey: "contact.frequency_rx1",                                  value: "Every Month" },
    { fieldKey: "contact.rx_2_name",                                      value: "Metformin" },
    { fieldKey: "contact.rx_2_dosage",                                    value: "500mg" },
    { fieldKey: "contact.rx_2_quantity",                                  value: "60" },
    { fieldKey: "contact.frequency_rx2",                                  value: "Every Month" },
  ],
}

export default function App() {
  const [sessionToken, setSessionToken] = useState<string | null>(null)
  const [contact, setContact] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [autosave, setAutosave] = useState(false)

  const params = new URLSearchParams(window.location.search)
  const urlContactId = params.get("contact_id") || params.get("contactId")
  const urlLocationId = params.get("location_id")
  const isStandalone = window.self === window.top && !window.opener && !urlContactId

  useEffect(() => {
    if (DEV_MODE || isStandalone) {
      setContact(MOCK_CONTACT)
      setSessionToken("dev-mock-token")
      setLoading(false)
    } else {
      initSession()
    }
  }, [])

  async function initSession() {
    try {
      const contactId = urlContactId

      if (!contactId) {
        setError("No contact loaded. Please close and reopen.")
        setLoading(false)
        return
      }

      let sessionBody: object

      if (urlLocationId) {
        sessionBody = { locationId: urlLocationId, contactId }
      } else {
        // No location_id in URL — fall back to GHL postMessage (direct embed).
        const encryptedUserData = await new Promise<string>((resolve, reject) => {
          const timeout = setTimeout(() => {
            reject(new Error("GHL user context timeout — are you inside a GHL iframe?"))
          }, 5000)

          window.top!.postMessage({ message: "REQUEST_USER_DATA" }, "*")

          const handler = ({ data }: MessageEvent) => {
            if (data.message === "REQUEST_USER_DATA_RESPONSE") {
              clearTimeout(timeout)
              window.removeEventListener("message", handler)
              resolve(data.payload)
            }
          }

          window.addEventListener("message", handler)
        })
        sessionBody = { encryptedUserData, contactId }
      }

      const sessionResponse = await fetch(
        `${SUPABASE_URL}/functions/v1/create-session`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(sessionBody),
        }
      )

      if (!sessionResponse.ok) {
        const err = await sessionResponse.json().catch(() => ({}))
        setError(err.error || `Session error (${sessionResponse.status})`)
        setLoading(false)
        return
      }

      const { sessionToken: token } = await sessionResponse.json()
      setSessionToken(token)

      const contactResponse = await fetch(
        `${SUPABASE_URL}/functions/v1/get-contact`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sessionToken: token }),
        }
      )

      if (!contactResponse.ok) {
        setError("Could not load contact data.")
        setLoading(false)
        return
      }

      const { contact: contactData, autosave: autosaveValue } = await contactResponse.json()

      setAutosave(autosaveValue ?? false)
      setContact(contactData)
      setLoading(false)
    } catch (err: any) {
      setError(err.message ?? "Could not load contact. Please close and reopen.")
      setLoading(false)
    }
  }

  async function handleAutosaveToggle(value: boolean) {
    setAutosave(value)
    if (DEV_MODE || isStandalone || !sessionToken) return
    try {
      await fetch(`${SUPABASE_URL}/functions/v1/update-setting`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sessionToken, autosave: value }),
      })
    } catch {}
  }

  if (loading) {
    return (
      <div className="status-screen">
        <p>Loading contact...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="status-screen error">
        <p>{error}</p>
      </div>
    )
  }

  return (
    <ContactForm
      contact={contact}
      sessionToken={sessionToken!}
      onUpdate={(updated) => setContact(updated)}
      devMode={DEV_MODE || isStandalone}
      autosave={autosave}
      onAutosaveToggle={handleAutosaveToggle}
    />
  )
}
